<script>

	import Layout from "@/layouts/legal"

	const rows = [
		{
			"name": "Modernizr",
			"url": "https://github.com/Modernizr/Modernizr",
			"license": "MIT",
			"licenseUrl": "https://opensource.org/licenses/MIT"
		},
		{
			"name": "lodash",
			"url": "https://github.com/lodash/lodash",
			"license": "MIT",
			"licenseUrl": "https://github.com/lodash/lodash/blob/master/LICENSE"
		},
		{
			"name": "jQuery",
			"url": "https://github.com/jquery/jquery",
			"license": "MIT",
			"licenseUrl": "https://github.com/jquery/jquery/blob/master/LICENSE.txt"
		},
		{
			"name": "jQuery Easing Plugin",
			"url": "https://github.com/gdsmith/jquery.easing",
			"license": "BSD",
			"licenseUrl": "https://github.com/gdsmith/jquery.easing/blob/master/LICENSE-BSD-3-Clause.txt"
		},
		{
			"name": "AngularJS",
			"url": "https://github.com/angular/angular.js/",
			"license": "MIT",
			"licenseUrl": "https://github.com/angular/angular.js/blob/master/LICENSE"
		},
		{
			"name": "Vue.js",
			"url": "https://github.com/vuejs/vue",
			"license": "MIT",
			"licenseUrl": "https://github.com/vuejs/vue/blob/dev/LICENSE"
		},
		{
			"name": "url-polyfill",
			"url": "https://github.com/lifaon74/url-polyfill",
			"license": "MIT",
			"licenseUrl": "https://github.com/lifaon74/url-polyfill/blob/master/LICENSE"
		},
		{
			"name": "FastClick",
			"url": "https://github.com/ftlabs/fastclick",
			"license": "MIT",
			"licenseUrl": "https://github.com/ftlabs/fastclick/blob/master/LICENSE"
		},
		{
			"name": "Moment.js",
			"url": "https://github.com/moment/moment",
			"license": "MIT",
			"licenseUrl": "https://github.com/moment/moment/blob/develop/LICENSE"
		},
		{
			"name": "Moment Timezone",
			"url": "https://github.com/moment/moment-timezone",
			"license": "MIT",
			"licenseUrl": "https://github.com/moment/moment-timezone/blob/develop/LICENSE"
		},
		{
			"name": "spin.js",
			"url": "https://github.com/fgnass/spin.js/",
			"license": "MIT",
			"licenseUrl": "https://github.com/fgnass/spin.js/blob/master/LICENSE.md"
		},
		{
			"name": "Waypoints",
			"url": "https://github.com/imakewebthings/waypoints",
			"license": "MIT",
			"licenseUrl": "https://github.com/imakewebthings/waypoints/blob/master/licenses.txt"
		},
		{
			"name": "imagesLoaded",
			"url": "https://github.com/desandro/imagesloaded",
			"license": "MIT",
			"licenseUrl": "https://desandro.mit-license.org/"
		},
		{
			"name": "Autolinker.js",
			"url": "https://github.com/gregjacobs/Autolinker.js/",
			"license": "MIT",
			"licenseUrl": "https://github.com/gregjacobs/Autolinker.js/blob/master/LICENSE"
		},
		{
			"name": "selectize.js",
			"url": "https://github.com/selectize/selectize.js",
			"license": "Apache",
			"licenseUrl": "https://github.com/selectize/selectize.js/blob/master/LICENSE"
		},
		{
			"name": "angular-svg-base",
			"url": "https://github.com/jeffbcross/angular-svg-base",
			"license": "MIT",
			"licenseUrl": "https://github.com/jeffbcross/angular-svg-base/blob/master/LICENSE"
		},
		{
			"name": "AngularUI Router",
			"url": "https://github.com/angular-ui/ui-router",
			"license": "MIT",
			"licenseUrl": "https://github.com/angular-ui/ui-router/blob/master/LICENSE"
		},
		{
			"name": "proxy-observe",
			"url": "https://github.com/anywhichway/proxy-observe",
			"license": "MIT",
			"licenseUrl": "https://github.com/anywhichway/proxy-observe/blob/master/LICENSE"
		},
		{
			"name": "js-data",
			"url": "https://github.com/js-data/js-data",
			"license": "MIT",
			"licenseUrl": "https://github.com/js-data/js-data/blob/master/LICENSE"
		},
		{
			"name": "js-data-angular",
			"url": "https://github.com/js-data/js-data-angular",
			"license": "MIT",
			"licenseUrl": "https://github.com/js-data/js-data-angular/blob/master/LICENSE"
		},
		{
			"name": "angular-notify",
			"url": "https://github.com/cgross/angular-notify",
			"license": "MIT",
			"licenseUrl": "https://github.com/cgross/angular-notify/blob/master/LICENSE"
		},
		{
			"name": "AngularUtilities",
			"url": "https://github.com/michaelbromley/angularUtils",
			"license": "MIT",
			"licenseUrl": "https://github.com/michaelbromley/angularUtils/blob/master/license.txt"
		},
		{
			"name": "ngDialog",
			"url": "https://github.com/likeastore/ngDialog",
			"license": "MIT",
			"licenseUrl": "https://github.com/likeastore/ngDialog#license"
		},
		{
			"name": "ngAudio",
			"url": "https://github.com/danielstern/ngAudio",
			"license": "MIT",
			"licenseUrl": "https://github.com/danielstern/ngAudio/blob/master/LICENSE"
		},
		{
			"name": "angular-google-analytics",
			"url": "https://github.com/revolunet/angular-google-analytics",
			"license": "MIT",
			"licenseUrl": "https://github.com/revolunet/angular-google-analytics/blob/master/LICENSE"
		},
		{
			"name": "ui-date",
			"url": "https://github.com/angular-ui/ui-date",
			"license": "MIT",
			"licenseUrl": "https://github.com/angular-ui/ui-date/blob/master/LICENSE"
		},
		{
			"name": "angular-selectize",
			"url": "https://github.com/machineboy2045/angular-selectize",
			"license": "MIT",
			"licenseUrl": "https://github.com/machineboy2045/angular-selectize/blob/master/LICENSE"
		},
		{
			"name": "angular-truncate",
			"url": "https://github.com/sparkalow/angular-truncate",
			"license": "MIT",
			"licenseUrl": "https://github.com/sparkalow/angular-truncate/blob/master/LICENSE"
		},
		{
			"name": "angular-breadcrumb",
			"url": "https://github.com/ncuillery/angular-breadcrumb",
			"license": "MIT",
			"licenseUrl": "https://github.com/ncuillery/angular-breadcrumb/blob/master/LICENSE"
		},
		{
			"name": "angular-filter",
			"url": "https://github.com/a8m/angular-filter",
			"license": "MIT",
			"licenseUrl": "https://github.com/a8m/angular-filter/blob/master/license.md"
		},
		{
			"name": "angular-PubSub",
			"url": "https://github.com/georapbox/angular-PubSub",
			"license": "MIT",
			"licenseUrl": "https://github.com/georapbox/angular-PubSub/blob/master/LICENSE"
		},
		{
			"name": "angular-xeditable",
			"url": "https://github.com/vitalets/angular-xeditable",
			"license": "MIT",
			"licenseUrl": "https://github.com/vitalets/angular-xeditable/blob/master/LICENSE"
		},
		{
			"name": "ngVue",
			"url": "https://github.com/ngVue/ngVue",
			"license": "MIT",
			"licenseUrl": "https://github.com/ngVue/ngVue/blob/master/LICENSE"
		},
		{
			"name": "angularjs-slider",
			"url": "https://github.com/angular-slider/angularjs-slider",
			"license": "MIT",
			"licenseUrl": "https://github.com/angular-slider/angularjs-slider/blob/master/LICENSE"
		},
		{
			"name": "patternomaly",
			"url": "https://github.com/ashiguruma/patternomaly/blob/master/LICENSE",
			"license": "MIT",
			"licenseUrl": "https://github.com/ashiguruma/patternomaly/blob/master/LICENSE"
		},
		{
			"name": "angular-chart.js",
			"url": "https://github.com/jtblin/angular-chart.js",
			"license": "MIT",
			"licenseUrl": "https://github.com/jtblin/angular-chart.js/blob/master/LICENSE"
		},
		{
			"name": "Snap.svg",
			"url": "https://github.com/adobe-webplatform/Snap.svg/",
			"license": "Apache",
			"licenseUrl": "https://github.com/adobe-webplatform/Snap.svg/blob/master/LICENSE"
		},
		{
			"name": "jQuery.picadiff",
			"url": "https://github.com/picapica-org/jQuery.picadiff",
			"license": "BSD",
			"licenseUrl": "https://github.com/picapica-org/jQuery.picadiff/blob/master/MIT-LICENSE.TXT"
		},
		{
			"name": "Sortable",
			"url": "https://github.com/SortableJS/sortablejs",
			"license": "MIT",
			"licenseUrl": "https://github.com/SortableJS/sortablejs/blob/master/LICENSE"
		},
		{
			"name": "jQuery UI",
			"url": "https://github.com/jquery/jquery-ui",
			"license": "MIT",
			"licenseUrl": "https://github.com/jquery/jquery-ui/blob/master/LICENSE.txt"
		},
		{
			"name": "jquery-ui-touch-punch-improved",
			"url": "https://github.com/Bantam/jquery-ui-touch-punch-improved",
			"license": "MIT",
			"licenseUrl": "http://touchpunch.furf.com/"
		},
		{
			"name": "lz-string",
			"url": "https://github.com/pieroxy/lz-string",
			"license": "MIT",
			"licenseUrl": "https://github.com/pieroxy/lz-string/blob/master/LICENSE"
		},
		{
			"name": "Cropper.js",
			"url": "https://github.com/fengyuanchen/cropperjs",
			"license": "MIT",
			"licenseUrl": "https://github.com/fengyuanchen/cropperjs/blob/master/LICENSE"
		},
		{
			"name": "Recorder.js",
			"url": "https://github.com/zlokomatic/Recorderjs",
			"license": "MIT",
			"licenseUrl": "https://github.com/zlokomatic/Recorderjs#license-mit"
		},
		{
			"name": "Tipsy.js",
			"url": "https://github.com/jaz303/tipsy",
			"license": "MIT",
			"licenseUrl": "https://github.com/jaz303/tipsy/blob/master/LICENSE"
		}
	]

	export default {
		components: { Layout },
		metaInfo () {
			return {
				title: `StudySync ${this.title}`
			}
		},
		data () {
			return {
				title: "Opensource Credits"
			}
		},
		render () {
			return (
				<Layout title={this.title}>
					<table>
						<thead>
							<tr>
								<th width="50%">Name</th>
								<th width="50%">License</th>
							</tr>
						</thead>
						<tbody>
							{rows.map((row) => (
								<tr>
									<td>
										<a href={row.url} target="_blank">{row.name}</a>
									</td>
									<td>
										<a href={row.licenseUrl} target="_blank">{row.license}</a>
									</td>
								</tr>
							))}
						</tbody>
					</table>
				</Layout>
			)
		}
	}

</script>

<style lang="scss" scoped>
	table {
		margin:0 auto; table-layout:fixed; border-collapse:collapse;
		th, td {
			text-align:center; border:1px solid rgba(#000, .15); padding:.15em;
		}
		tr:nth-child(odd) td {
			background:rgba(#000, .075)
		}
	}
</style>



// WEBPACK FOOTER //
// src/routes/legal/opensource-credits.vue